import cx from 'classnames';

import { BudgetaryExerciseDropdownMenu } from 'src/core/modules/budgets/components/BudgetaryExerciseDropdownMenu';
import { useBudgetaryExerciseModals } from 'src/core/modules/budgets/hooks/useBudgetaryExerciseModals';

import { ExportBudgetButton } from '../../../../components/ExportBudgetButton';
import { type BudgetaryExercise } from '../../../../models/budgetaryExercise';
import { type PeriodRange } from '../../../../models/periodRange';
import { BudgetPeriodSelector } from '../BudgetPeriodSelector';

export const BudgetaryExerciseActionsBar = ({
  budgetaryExercise,
  canEditBudgets,
  className,
  title,
  onRangeChange,
  range,
  align = 'left',
}: {
  budgetaryExercise: BudgetaryExercise;
  canEditBudgets: boolean;
  className?: string;
  title?: string;
  onRangeChange: (range: PeriodRange) => void;
  range: PeriodRange;
  align?: 'left' | 'right';
}) => {
  const { budgets } = budgetaryExercise;
  const hasBudgets = budgets.length !== 0;

  const { modals, handlers } = useBudgetaryExerciseModals(budgetaryExercise);

  return (
    <div
      className={cx(
        'flex w-full items-center justify-between gap-8',
        className,
      )}
    >
      {modals.budgetaryExerciseDeletionConfirmationModal}
      {modals.editBudgetExpenseCategoriesModal}
      {modals.budgetaryExerciseEditionModal}
      {title && <div className="heading-l grow">{title}</div>}
      <BudgetPeriodSelector
        range={range}
        align={align}
        maxRange={{
          from: budgetaryExercise.startDate,
          to: budgetaryExercise.endDate,
        }}
        onChange={onRangeChange}
      />
      <div className="flex gap-8">
        <ExportBudgetButton budgetIds={budgets.map((b) => b.id)} />
        {canEditBudgets && (
          <BudgetaryExerciseDropdownMenu
            hasBudgets={hasBudgets}
            onEdit={handlers.showEdit}
            onDelete={handlers.showDelete}
            onUpdateBudgets={handlers.showUpdateBudgets}
          />
        )}
      </div>
    </div>
  );
};
